
<template>
  <div class="page view_qrcode">
    <div class="qrcode_container">
      <qrcode-stream class="qrcode_stream" @decode="onDecode"></qrcode-stream>
      <div class="border_container">
        <div class="border top left" />
        <div class="border top right" />
        <div class="border bottom left" />
        <div class="border bottom right" />
      </div>
    </div>

    <div>
      <button class="buttonLink" :disabled="!target" @click="next">Flashez le QR Code</button>
    </div>

    <button @click="autovalidate" style="position: absolute; bottom: 5px; right: 5px">Auto Validate QRCODE</button>
  </div>
  
</template>

<script>

import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'QrCode',
  components: {QrcodeStream},
  data () {
    return {
      target: null
    }
  },
  methods: {
    onDecode: function(decoded) {

      var qrcode_to = {
        "test1": "place1",
        "test2": "place2",
        "test3": "place3",
        "test4": "place4"
      }
      // [qrcode]: [page target]

      console.log('Qrcode : ', decoded);
      if (!decoded || !qrcode_to[decoded]) {
        this.target = null;
        return ;
      }

      // Dès qu'il y a un scan valide, on enregistre la target, et on change de page dès l'appuie sur le bouton
      this.target = qrcode_to[decoded];
    },
    autovalidate: function() {
      var target = window.localStorage.getItem('target');
      this.target = target;
    },
    next: function() {
      this.$router.push(this.target);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  .view_qrcode {
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .buttonLink {
      max-width: unset !important;
    margin: 20px auto;
    padding: 10px 10px;
    font-size: 1.5em;

    }

  }

  .qrcode_container {
    height: 300px;
    width: 300px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5vh;

    .qrcode_stream {
      position: absolute; 
      height: 250px; 
      width: 250px; 
      background-color: black
    }

    .border_container {
      position: absolute;
      width: 100%;
      height: 100%;
      .border {
        position: absolute;
        height: 25%;
        width: 25%;
        border: solid 0 red;

        &.top {
          top: 0;
          border-top-width: 5px;
        }

        &.bottom {
          bottom: 0;
          border-bottom-width: 5px;
        }

        &.left {
          left: 0;
          border-left-width: 5px;
        }

        &.right {
          right: 0;
          border-right-width: 5px;
        }

      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/QRCode.vue